import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { useFormContext, Controller } from 'react-hook-form'

import styles from './formItem.module.scss'

const FormItem = ({
  label,
  input,
  registerOptions,
  useController,
  expand,
  position
}) => {
  const { register, errors, control, clearErrors } = useFormContext()
  const inputError = errors[input.props.name]
  const inputContent = useController ? (
    <Controller
      render={({ onChange, props }) => {
        return (
          <input.type
            {...input.props}
            {...props}
            error={input.props.error || inputError?.message}
            onChange={(data) => {
              input.props.onChange && input.props.onChange(data)
              onChange(data)
            }}
          />
        )
      }}
      {...input.props}
      control={control}
      rules={registerOptions}
    />
  ) : (
    <input.type
      {...input.props}
      ref={register(registerOptions)}
      error={input.props.error || inputError?.message}
      clearErrors={clearErrors}
    />
  )
  return (
    <div
      className={classNames(styles.container, styles[position])}
      style={{ flexGrow: expand || 'inherit' }}
    >
      <div> {label} </div>
      {inputContent}
    </div>
  )
}

FormItem.propTypes = {
  label: PropTypes.node,
  input: PropTypes.node.isRequired,
  registerOptions: PropTypes.object,
  useController: PropTypes.bool
}

FormItem.defaultProps = {
  registerOptions: {},
  useController: false
}

export default FormItem
